// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header-cell {
    font-weight: bold;
    border: 1px solid lightgray;
    text-align: center;
    width: 300px;
    color: white;
    padding: 0;
  }

 

.candidateProfiletable-cell {
  border: 1px solid lightgray;
   padding: 8px ;
   text-align: center;
}

.candidateProfiletable-cell-head{
 
 font-weight: bold;
  color: lightgray;
   border: 1px solid lightgray;
   text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/HiringdashBoard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;;;AAIF;EACE,2BAA2B;GAC1B,aAAa;GACb,kBAAkB;AACrB;;AAEA;;CAEC,iBAAiB;EAChB,gBAAgB;GACf,2BAA2B;GAC3B,kBAAkB;AACrB","sourcesContent":[".table-header-cell {\n    font-weight: bold;\n    border: 1px solid lightgray;\n    text-align: center;\n    width: 300px;\n    color: white;\n    padding: 0;\n  }\n\n \n\n.candidateProfiletable-cell {\n  border: 1px solid lightgray;\n   padding: 8px ;\n   text-align: center;\n}\n\n.candidateProfiletable-cell-head{\n \n font-weight: bold;\n  color: lightgray;\n   border: 1px solid lightgray;\n   text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
